import { useCallback, useEffect, useState } from 'react';
import useGTM from '@elgorditosalsero/react-gtm-hook';

const useGtmEventTracking = () => {
  const { init } = useGTM();
  const [gtmInitialised, setGtmInitialised] = useState(false);

  useEffect(() => {
    const id = process.env.REACT_APP_GTM_ID;
    const dataLayerName = process.env.REACT_APP_GTM_DATA_LAYER_NAME;

    if (!id || !dataLayerName) {
      return;
    }

    init({
      id: id,
      dataLayerName: dataLayerName,
    });
    setGtmInitialised(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return useCallback(
    (event: any) => {
      if (gtmInitialised) {
        const dataLayerName = process.env.REACT_APP_GTM_DATA_LAYER_NAME || 'dataLayer';
        if (window[dataLayerName as any]) {
          (window as any)[dataLayerName].push(event);
        }
      }
    },
    [gtmInitialised],
  );
};

export default useGtmEventTracking;
